module.exports = __webpack_public_path__ + "media/components/assets/icons/closeSm-986ef6c91b19e61948ff1cbb56cf0d8a.svg";